import ToolTipCell from './ToolTipCell';

export default ToolTipCell;
